import { type CompanyStore } from "services/company/companyStore";
import { type CompanyAddressStore } from "services/companyAddress/au/companyAddressStore";
import { type FeatureStore } from "services/feature/featureStore";
import { type IssuesStore } from "services/issues/issuesStore";
import { QuestionsStore } from "services/questions/questionsStore";
import { CompanyAcnQuestion } from "./companyConstants";

export class CompanyAcnQuestionsStore extends QuestionsStore<CompanyAcnQuestion> {
  constructor(
    private readonly _companyStore: CompanyStore,
    private readonly _companyAddressStore: CompanyAddressStore,
    protected readonly _issuesStore: IssuesStore,
    private readonly _featureStore: FeatureStore,
  ) {
    super(CompanyAcnQuestion, _issuesStore);
  }

  protected _getRelevantQuestion(): CompanyAcnQuestion | undefined {
    const { company } = this._companyStore;

    if (!this._companyAddressStore.address) {
      return CompanyAcnQuestion.VirtualOffice;
    }

    if (typeof this._companyAddressStore.address.isOwnedByCompany === "undefined" && !company?.useVirtualOffice) {
      return CompanyAcnQuestion.Occupier;
    }

    if (this._isAsicNominationEnabled() && typeof company?.auAsicAgentNominationRequested === "undefined") {
      return CompanyAcnQuestion.AsicAgentNomination;
    }

    return undefined;
  }

  protected _shouldSkipQuestion(question: CompanyAcnQuestion): boolean {
    const { company } = this._companyStore;

    if (question === CompanyAcnQuestion.VirtualPlanSelect) {
      return this._companyStore.skipVOBillingPeriod();
    }

    if (question === CompanyAcnQuestion.VirtualAddressSelect) {
      return this._companyStore.skipVOAddressSelection();
    }

    if (question === CompanyAcnQuestion.Occupier && company?.useVirtualOffice) {
      return true;
    }

    if (question === CompanyAcnQuestion.AsicAgentNomination && !this._isAsicNominationEnabled()) {
      return true;
    }

    return super._shouldSkipQuestion(question);
  }

  private _isAsicNominationEnabled(): boolean {
    return this._featureStore.hasFeature("formationAsicNomination");
  }
}
